import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewEncapsulation
} from '@angular/core';
import { KazaplanFullscreenService } from '../kazaplan-fullscreen.service';
import { Location } from '@angular/common';
import { KazaplanFullscreenComponent } from '../kazaplan-fullscreen/kazaplan-fullscreen.component';
import { Router } from '@angular/router';
import { take, tap } from 'rxjs/operators';
import { AutoUnsubscribe } from '../../../../utils/misc/auto-unsubscribe';
import { Subscription } from 'rxjs';
import { ToastrService } from '../../../../shared/services/utilities/toastr.service';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { KazaplanAction } from '../../kazaplan-options-v2/kazaplan-option-actions';
import { KzModal } from '../../../../kz-ui/ui/modal/kz-modal';
import { ModalClosureType } from '../../../../utils/modals/modals-closure-types';
import { KazaplanService } from '../../kazaplan.service';
import { KzIconsRegistryService } from '../../../../kz-ui/ui/icon/kz-icons-registry.service';
import { kzIconsCross } from '../../../../kz-ui/ui/icon/generated-icons/kzIcons-cross.icon';
import { KazaPlanService } from '@adeo/ngx-kozikaza-api/kazaplan';

@Component({
  selector: 'app-kazaplan-fullscreen-popin',
  templateUrl: './kazaplan-fullscreen-popin.component.html',
  styleUrls: ['../kazaplan-fullscreen/kazaplan-fullscreen.component.scss', './kazaplan-fullscreen-popin.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
@AutoUnsubscribe()
export class KazaplanFullscreenPopinComponent extends KazaplanFullscreenComponent implements OnInit, OnDestroy {

  public closureType = ModalClosureType;
  private getCurrentKazaplanSubscription: Subscription;

  public inputData: any;

  constructor(
    protected toastrService: ToastrService,
    protected cdr: ChangeDetectorRef,
    protected location: Location,
    public kfs: KazaplanFullscreenService,
    protected router: Router,
    @Inject(PLATFORM_ID) protected platformId,
    public modal: KzModal<KazaplanFullscreenPopinComponent>,
    protected readonly localizeRouterService: LocalizeRouterService,
    protected readonly kazaplanService: KazaplanService,
    private readonly kazaPlanService:KazaPlanService,
    private kzIconsRegistryService: KzIconsRegistryService,
  ) {
    super(toastrService, cdr, location, kfs, router, platformId, localizeRouterService, kazaplanService ,kazaPlanService);
    this.kzIconsRegistryService.registerIcons([kzIconsCross]);
  }

  ngOnInit() {
    if (!this.inputData) {
      this.toastrService.error($localize`:@@toast.could_not_load_kaza:Can not load Kaza`);
      this.closeDialog(null);
    }

    this.planId = this.inputData.plan.id;
    if (this.inputData.planMediaId) {
      this.mediaId = this.inputData.planMediaId;
    }
    if (this.inputData.filterMedias) {
      this.kfs.setPlanMediasFilter({page: 1, mediaFilter: this.inputData.filterMedias});
    } else {
      this.kfs.setPlanMediasFilter({page: 1, mediaFilter: null});
    }
    this.kazaplanMediasSubscription = this.initPlanMedias().subscribe();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.kazaplanMediasSubscription) {
      this.kazaplanMediasSubscription.unsubscribe();
    }
  }

  closeDialog(closureType: ModalClosureType, action?: KazaplanAction): void {
    this.getCurrentKazaplanSubscription = this.kfs.getCurrentKazaplan().pipe(
      take(1),
      tap((kazaplan) => {
        const result = { kazaplan };
        if (action) {
          result[`action`] = action;
        }
        this.modal.close({closureType, result});
      })
    ).subscribe();
  }
}
